<template>
    <MetricsDashboard :entity-id="entityId" :entity-type="entityType">
        <template #child-section="{ hours, stekRelease, entityId: productId }">
            <AllProcessesSection
                v-if="productId"
                :product-id="productId"
                :hours="hours"
                :stek-release="stekRelease"
            />
        </template>
    </MetricsDashboard>
</template>

<script setup lang="ts">
import AllProcessesSection from "./AllProcessesSection.vue";
import MetricsDashboard from "./MetricsDashboard.vue";

defineOptions({
    name: "ProductDashboard",
});

defineProps<{
    entityId: string;
    entityType: string;
}>();
</script>
